import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";

import fetchMe from "../../utils/fetchMe";
import {
  DRIVER_ACCOUNT_MESSAGE,
  OPERATOR_ROLE,
  clearAuthTokens,
  getOperatorAuthError,
  setLoginFlag,
} from "../../utils/operatorAuth";

const GoogleOperatorAuth = ({ mode = "signin", onError, onLoadingChange }) => {
  const actionText = mode === "signup" ? "зарегистрироваться" : "войти";

  const finishLogin = async (tokens) => {
    const user = await fetchMe(tokens.access);
    const authError = getOperatorAuthError(user);

    if (authError) {
      clearAuthTokens();
      onError(authError);
      return;
    }

    window.localStorage.setItem("access", tokens.access);
    window.localStorage.setItem("refresh", tokens.refresh);
    setLoginFlag();
    window.location.reload();
  };

  const handleSuccess = async ({ credential }) => {
    if (!credential) {
      onError("Не удалось получить данные Google аккаунта. Попробуйте еще раз.");
      return;
    }

    onLoadingChange(true);
    onError(null);

    try {
      const { data, status } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/google/`,
        {
          id_token: credential,
          role: OPERATOR_ROLE,
        },
      );

      if (status === 200 || status === 201) {
        await finishLogin(data);
      }
    } catch (error) {
      console.log(error.response?.status, error.response?.data);

      const responseData = error.response?.data;
      if (
        error.response?.status === 409 &&
        (responseData?.error === "EMAIL_REGISTERED_AS_DRIVER" ||
          responseData?.code === "EMAIL_REGISTERED_AS_DRIVER" ||
          responseData?.role === "DRIVER")
      ) {
        onError(DRIVER_ACCOUNT_MESSAGE);
      } else if (
        error.response?.status === 401 &&
        error.response?.data?.detail === "-1"
      ) {
        onError("Аккаунт находится на модерации");
      } else {
        onError(`Не удалось ${actionText} через Google. Попробуйте другой аккаунт.`);
      }
    } finally {
      onLoadingChange(false);
    }
  };

  return (
    <div className="login__google">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={() =>
          onError(`Не удалось ${actionText} через Google. Попробуйте еще раз.`)
        }
        text={mode === "signup" ? "signup_with" : "signin_with"}
        width="300"
      />
    </div>
  );
};

export default GoogleOperatorAuth;
